// Convert pixels to rems
// based on base font of the app which is 14px
// eg. for a relational value of 12px write pxToRem(12)
export function pxToRem(pixels: number, base = 14) {
  return `${(pixels / base) * 1}rem`;
}
